import { render, staticRenderFns } from "./reception.vue?vue&type=template&id=4e9ffcbc&scoped=true&"
import script from "./reception.vue?vue&type=script&lang=js&"
export * from "./reception.vue?vue&type=script&lang=js&"
import style0 from "./reception.vue?vue&type=style&index=0&id=4e9ffcbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9ffcbc",
  null
  
)

export default component.exports